import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const StudyProduct = () => {
    return (
        <div className="study-product-wrapper">
            <div className="container container-xl-small">
                <div className="title-study-product">
                    <h2 className="text">نقد و بررسی اجمالی</h2>
                </div>
                <div className="text-content">
                    <p>
                        <span>
                        گوشی ردمی نوت۹ شیائومی محصول ۳۰ آوریل ۲۰۲۰ است. سری ردمی‌نوت ۹ شیائومی شامل چهار گوشی ردمی نوت
                        ۹، ردمی نوت ۹پرو و ردمی نوت۹اس و ردمی نوت۹ پرو مکس است که در این بخش شاهد نسخه‌ی پایه یعنی ردمی
                        نوت ۹ می‌باشید.
                        این نسخه از تراشه‌ی هلیو جی ۸۵ مدیاتک و یک پردازنده‌ی ۸ هسته‌ای بهره می‌برد. نمایشگر ۶.۵۳ اینچی،
                        باتری ۵۰۲۰ میلی آمپر ساعتی و حسگر اثر انگشت در قسمت پشتی از ویژگی‌های اصلی این گوشی محسوب
                        می‌شود.
                      </span>
                        <span>
                        این گوشی از ۱۲۸ گیگابایت حافظه داخلی و ۴ گیگابایت رم برخوردار است. علاوه بر این‌ها، یک دوربین
                        ۴گانه مربعی شکل در پشت گوشی قرار دارد که از سنسور اصلی سامسونگ GM1 با رزولوشن ۴۸ مگایپسکلی در
                        کنار دوربین ۸ مگاپیکسلی زاویه دید عریض و دو دوربین ۲ مگاپیکسلی عمق سنج و ماکرو برخوردار است.
                        این گوشی به حسگرهای اثرانگشت (پشت گوشی)، شتاب‌سنج، سنسور مجاورت، قطب‌نما مجهز است.
                    </span>
                        <span>
                        از جمله‌ی تفاوت‌های ردمی نوت ۹ با سایر گوشی‌های این سری از برند شیائومی می‌توان به این موارد
                        اشاره کرد:
                      </span>
                        <span>
                        ردمی نوت ۹ با ۱۹۹ گرم وزن از سه گوشی دیگر با ۲۰۹ گرم وزن سبک‌تر و کوچک‌تر است. سه مدل دیگر از
                        نمایشگر بزرگ‌تر برخوردارند و جثه‌ی بزرگ‌تری نیز دارند. نوت ۹ دارای یک اسکنر اثر انگشت روی قاب
                        پشتی خود است، در حالی که این اسکنر روی فریم کناری سه مدل دیگر قرار دارد. از جمله تفاوت‌های دیگر
                        می‌توان به پردازنده‌ی آن‌ها اشاره کرد. همان‌طور که گفتیم نوت ۹ از پردازنده‌ی هلیو جی ۸۵ مدیاتک
                        استفاده می‌کند، اما سه گوشی دیگر به اسنپدراگون ۷۲۰ جی مجهز هستند.
                            </span>
                    </p>
                </div>
                <div className="button-more-text more-text-study-product d-block d-lg-none">
                    <IconName name="receipt_long" className="icon study-icon"/>
                    <span className="text">بررسی محصول</span>
                    <IconName name="chevron_left" className="icon more-icon position-absolute"/>
                </div>
                <div className="img-study-product d-none d-lg-block">
                    <ul className="nav">
                        <li className="nav-item position-relative">
                            <a href="#" className="nav-link">
                                <img src="./assets/sample-image/DSC02842.png" alt="img"/>
                                <span className="text position-absolute">بررسی ردمی نوت 9 پرو</span>
                            </a>
                        </li>
                        <li className="nav-item position-relative video-play">
                            <a href="#" className="nav-link">
                                <img src="./assets/sample-image/d12c6c8f65b61af7900dfc3760d7b96a.png" alt="img"/>
                                <span className="text position-absolute">جعبه گشایی از ردمی نوت 9 پرو</span>
                                <span className="play position-absolute">
                                    <IconName name="play-icon" className="icon position-relative"/>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="slide-study-product d-block d-lg-none xmt-6">
                    <div className="title">
                        <div className="title-box just-text title-box-blue">
                            <div className="title-bg">
                                <h2 className="text">
                                    مطالب مرتبط
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="swiper study-product-slide  position-relative xpt-6">
                        <div className="swiper-scrollbar-study-product position-absolute">
                        </div>
                        <div className="swiper-wrapper">

                            <div className="swiper-slide">
                                <a href="#" className="nav-link">
                                    <img src="./assets/sample-image/DSC02842.png" alt="img"/>
                                    <span className="text position-absolute">بررسی ردمی نوت 9 پرو</span>
                                </a>
                            </div>
                            <div className="swiper-slide">
                                <a href="#" className="nav-link">
                                    <img src="./assets/sample-image/d12c6c8f65b61af7900dfc3760d7b96a.png" alt="img"/>
                                    <span className="text position-absolute">جعبه گشایی از ردمی نوت 9 پرو</span>
                                    <span className="play position-absolute">
                                    <IconName name="play-icon" className="icon position-relative"/>
                                </span>
                                </a>
                            </div>
                            <div className="swiper-slide">
                                <a href="#" className="nav-link">
                                    <img src="./assets/sample-image/DSC02842.png" alt="img"/>
                                    <span className="text position-absolute">بررسی ردمی نوت 9 پرو</span>
                                </a>
                            </div>
                            <div className="swiper-slide">
                                <a href="#" className="nav-link">
                                    <img src="./assets/sample-image/d12c6c8f65b61af7900dfc3760d7b96a.png" alt="img"/>
                                    <span className="text position-absolute">جعبه گشایی از ردمی نوت 9 پرو</span>
                                    <span className="play position-absolute">
                                    <IconName name="play-icon" className="icon position-relative"/>
                                </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="study-product-responsive-wrapper d-block d-lg-none position-fixed">
                <div className="header-study-product-responsive xpy-3 xpx-4">
                    <div className="back-study-responsive">
                        <IconName name="arrow_back" className="icon"/>
                        <span className="text-header">نقد و بررسی</span>
                    </div>
                </div>
                <div className="content-study-product-responsive">
                    <div className="title">
                        <h3>نقد و بررسی اجمالی</h3>
                    </div>
                    <p className="content-text">
                        گوشی ردمی نوت۹ شیائومی محصول ۳۰ آوریل ۲۰۲۰ است. سری ردمی‌نوت ۹ شیائومی شامل چهار گوشی ردمی نوت
                        ۹، ردمی نوت ۹پرو و ردمی نوت۹اس و ردمی نوت۹ پرو مکس است که در این بخش شاهد نسخه‌ی پایه یعنی ردمی
                        نوت ۹ می‌باشید.
                        این نسخه از تراشه‌ی هلیو جی ۸۵ مدیاتک و یک پردازنده‌ی ۸ هسته‌ای بهره می‌برد. نمایشگر ۶.۵۳ اینچی،
                        باتری ۵۰۲۰ میلی آمپر ساعتی و حسگر اثر انگشت در قسمت پشتی از ویژگی‌های اصلی این گوشی محسوب
                        می‌شود.
                    </p>
                    <div className="img-product xmy-8 d-flex justify-content-center">
                        <img src="./assets/sample-image/d12c6c8f65b61af7900dfc3760d7b96a.png" alt="ss"/>
                    </div>
                    <p className="content-text">
                        <span>
                        این گوشی از ۱۲۸ گیگابایت حافظه داخلی و ۴ گیگابایت رم برخوردار است. علاوه بر این‌ها، یک دوربین
                        ۴گانه مربعی شکل در پشت گوشی قرار دارد که از سنسور اصلی سامسونگ GM1 با رزولوشن ۴۸ مگایپسکلی در
                        کنار دوربین ۸ مگاپیکسلی زاویه دید عریض و دو دوربین ۲ مگاپیکسلی عمق سنج و ماکرو برخوردار است.
                        این گوشی به حسگرهای اثرانگشت (پشت گوشی)، شتاب‌سنج، سنسور مجاورت، قطب‌نما مجهز است.
                            </span>
                        <span>
                        از جمله‌ی تفاوت‌های ردمی نوت ۹ با سایر گوشی‌های این سری از برند شیائومی می‌توان به این موارد
                        اشاره کرد:
                        </span>
                        <span>
                        ردمی نوت ۹ با ۱۹۹ گرم وزن از سه گوشی دیگر با ۲۰۹ گرم وزن سبک‌تر و کوچک‌تر است. سه مدل دیگر از
                        نمایشگر بزرگ‌تر برخوردارند و جثه‌ی بزرگ‌تری نیز دارند. نوت ۹ دارای یک اسکنر اثر انگشت روی قاب
                        پشتی خود است، در حالی که این اسکنر روی فریم کناری سه مدل دیگر قرار دارد. از جمله تفاوت‌های دیگر
                        می‌توان به پردازنده‌ی آن‌ها اشاره کرد. همان‌طور که گفتیم نوت ۹ از پردازنده‌ی هلیو جی ۸۵ مدیاتک
                        استفاده می‌کند، اما سه گوشی دیگر به اسنپدراگون ۷۲۰ جی مجهز هستند.
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default StudyProduct;
